import React from 'react';
import { DropdownItemProps, Table } from 'semantic-ui-react';
import { PaginationProps } from 'semantic-ui-react/dist/commonjs/addons/Pagination/Pagination';
import Pagination from '../Pagination';

interface Props {
  onPageChange: (
    event: React.MouseEvent<HTMLAnchorElement>,
    data: PaginationProps
  ) => void;
  onPageSizeChange?: (pageSize: number) => void;
  pageCount: number;
  pageIndex: number;
  columns: number;
  totalRows?: number;
  showRowsPerPageSelection?: boolean;
  dropDownOptions?: DropdownItemProps[];
}

export const TableFooter = (props: Props) => {
  return (
    <Table.Footer>
      <Table.Row textAlign="right">
        <Table.HeaderCell colSpan={props.columns}>
          <Pagination
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            pageCount={props.pageCount}
            pageIndex={props.pageIndex}
            totalRows={props.totalRows}
            showRowsPerPageSelection={props.showRowsPerPageSelection}
            dropDownOptions={props.dropDownOptions}
          />
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  );
};
